import React from 'react';

export const LoanCalculatorFormGroup = ({
    label,
    id,
    value,
    handleFieldChange,
    step,
}: any) => {
    return (
        <div>
            {label && <label className="FormGroup__label">{label}</label>}
            {value && step && (
                <div className="FormGroup">
                    <div
                        onClick={() => handleFieldChange(id, value - step)}
                        className="FormGroup__control FormGroup__control--left"
                    >
                        -
                    </div>
                    <input
                        type="number"
                        value={value}
                        onChange={(event) => {
                            const value = parseInt(event.target.value, 10);
                            return handleFieldChange(
                                id,
                                isNaN(value) ? 0 : value,
                            );
                        }}
                        className="FormGroup__number"
                    />
                    <div
                        onClick={() => handleFieldChange(id, value + step)}
                        className="FormGroup__control FormGroup__control--right"
                    >
                        +
                    </div>
                </div>
            )}
        </div>
    );
};
